import { render } from "./MusicNotes.vue?vue&type=template&id=294e45d8&scoped=true"
import script from "./MusicNotes.vue?vue&type=script&lang=js"
export * from "./MusicNotes.vue?vue&type=script&lang=js"

import "./MusicNotes.vue?vue&type=style&index=0&id=294e45d8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/logexpo/logexpo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-294e45d8"]])

export default __exports__